import { render } from "./enrolments-table-group-selector.vue?vue&type=template&id=b2a9e468&ts=true"
import script from "./enrolments-table-group-selector.ts?vue&type=script&lang=ts&external"
export * from "./enrolments-table-group-selector.ts?vue&type=script&lang=ts&external"

import "./enrolments-table-group-selector.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__